"use client";

import { useTenantBranding } from "@/app/context/TenantBrandingContext";
import { FALLBACK_SUPPORT_EMAIL } from "@/app/utils/constants/constants";
import { isEmailAddress } from "@/app/utils/validation/contact";

/** Support inbox of the current tenant, or the platform inbox when unset. */
export function useSupportEmail(): string {
  const { contactEmail } = useTenantBranding();
  const email = contactEmail?.trim() ?? "";

  return isEmailAddress(email) ? email : FALLBACK_SUPPORT_EMAIL;
}
